/**
 * Comunicaciones — llamadas al backend (functions/comunicaciones).
 * El cliente no lee ni escribe la colección: todo pasa por los callables.
 * Habi redacta por propia_agent (/api/generate-comunicacion).
 */
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import { HABI_API_BASE_URL, getAuthHeaders } from "../habiApi";

// vistaPrevia y enviar arman el PDF con Chromium; enviar además manda el primer lote.
const TIMEOUT_MS = { vistaPrevia: 120000, enviar: 300000, reenviar: 120000 };

const llamar = async (nombre, op, data) => {
  const fn = TIMEOUT_MS[op] ? httpsCallable(functions, nombre, { timeout: TIMEOUT_MS[op] }) : httpsCallable(functions, nombre);
  const res = await fn({ op, ...data });
  return res.data;
};

/** Staff: listar, detalle, guardar, eliminar, vistaPrevia, destinatarios, enviar, estado, reenviar, pdf. */
export const comunicacionAdmin = (op, data = {}) => llamar("comunicacionAdmin", op, data);

/** Residente: listar (las que le mandaron) y pdf. */
export const comunicacionResidente = (op, data = {}) => llamar("comunicacionResidente", op, data);

/**
 * Habi arma la comunicación desde los puntos sueltos del admin. Devuelve los
 * bloques (asunto, titulo, loImportante, pasos, mediosPago, secciones); lo que
 * no sabe lo deja como [A COMPLETAR].
 */
export async function redactarConHabi({ buildingId, notas, destinatarios }) {
  const headers = await getAuthHeaders();
  const res = await fetch(`${HABI_API_BASE_URL}/api/generate-comunicacion`, {
    method: "POST",
    headers: { ...headers, "Content-Type": "application/json" },
    body: JSON.stringify({ building_id: String(buildingId), notas, destinatarios }),
  });
  if (!res.ok) {
    let detalle = "";
    try {
      detalle = (await res.json()).detail || "";
    } catch (_) {
      /* sin cuerpo */
    }
    throw new Error(detalle || "Habi no pudo armar la comunicación. Probá de nuevo.");
  }
  return res.json();
}

export const mensajeDeError = (e) => {
  const msg = e && e.message ? String(e.message) : "";
  return msg.replace(/^(FirebaseError:\s*)/, "") || "No se pudo completar la acción.";
};

export const codigoDeError = (e) => String((e && e.code) || "").replace(/^functions\//, "");
export const motivoDeError = (e) => (e && e.details && typeof e.details === "object" ? e.details.motivo || null : null);
